<template>
    <img :src="this.data.small" v-bind:style="{ 'width': width + 'px','max-width': '98%' }" alt="intablefig"/>
</template>

<script>
export default {
  props: [
    'data'
  ],
  data () {
    return {
      width: 10
    }
  },
  methods: {

  },
  created () {
    this.width = this.data.width * this.GLOBAL.deviceDPI.x / 25.4
  }
}
</script>

<style lang="scss" scoped>
    img {
        vertical-align: middle;
    }
</style>




// WEBPACK FOOTER //
// src/components/maincontent/body/fig/intablefig.vue